import React from 'react';
import { Box, Container, Divider, Typography } from '@mui/material';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';

export default function BenefitedDepartments() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" py={6}>
        <Container>
          <Box className={classes.mainContentBox} py={6}>
            <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
              <b>Departments that can benefit from Mind the Graph</b>
            </Typography>

            <Box py={2}>
              <Typography variant="h6" component="p" align="center">
                A range of 80+ fields of study covered in our gallery. Check them out.
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-around" alignItems="center" pr={5}>
              <ul className={classes.list}>
                <li>* Cardiology</li>
                <li>* Neurology</li>
                <li>* Urology</li>
                <li>* Gynecology</li>
                <li>* Obstetrics</li>
                <li>* Pneumology</li>
              </ul>

              <Divider className={classes.verticalDivider} />

              <ul className={classes.list}>
                <li>* Endocrinology</li>
                <li>* Orthopedics</li>
                <li>* Pediatrics</li>
                <li>* Hematology</li>
                <li>* Parasitology</li>
                <li>* Odontology</li>
              </ul>

              <Divider className={classes.verticalDivider} />

              <ul className={classes.list}>
                <li>* Pharmacy</li>
                <li>* Veterinary</li>
                <li>* Zoology</li>
                <li>* Biology</li>
                <li>* Botany</li>
                <li>* Entomology</li>
              </ul>

              <Divider className={classes.verticalDivider} />

              <ul className={classes.list}>
                <li>* Ornithology</li>
                <li>* Oceanography</li>
                <li>* Chemistry</li>
                <li>* Genetics</li>
                <li>* Nanotechnology</li>
                <li>* Geography</li>
              </ul>

              <Divider className={classes.verticalDivider} />

              <ul className={classes.list}>
                <li>* Physics & Astronomy</li>
                <li>* History</li>
                <li>* Engineering</li>
                <li>* Nutrition</li>
                <li>* Molecular science</li>
                <li>* Among others</li>
              </ul>
            </Box>

            <Box textAlign="center" pt={4}>
              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton>Request a Demonstration</CustomButton>
              </NextLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
